import moment from 'moment';
import React from 'react';
import { CURRENCY_CODE, DATE_FORMAT, DATE_FORMAT_WITH_TIME } from './constant.js';

export function GetYearLabel(index) {
  const suffixes = ['th', 'st', 'nd', 'rd'];
  const v = index % 100;
  return index + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]) + ' Year';
}

export const formatDate = (date, includeTime = false) => {
  if (date) {
    try {
      if (includeTime) {
        return moment(date).format(DATE_FORMAT_WITH_TIME || 'DD/MM/YYYY, h:mm:ss A');
      } else {
        return moment(date).format(DATE_FORMAT || 'DD/MM/YYYY');
      }
    } catch (e) {
      console.error(e);
      return '-';
    }
  } else {
    return '-';
  }
};

export const dateFormat = (date) => {
  return date ? moment(date).format('DD MMMM YYYY') : '-';
};

export const currencyFormatter = (number = 0, code = CURRENCY_CODE.INR) => {
  return new Intl.NumberFormat('en-IN', {
    maximumSignificantDigits: 3,
    style: 'currency',
    currency: code,
  }).format(number);
};

export const serialize = (obj) => {
  var str = [];
  for (var p in obj) {
    if (obj.hasOwnProperty(p) && obj[p]) {
      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
    }
  }
  return str.join('&');
};

export const _deepClone = (data) => {
  if (Array.isArray(data)) {
    return data.map((dt) => {
      return _deepClone(dt);
    });
  } else if (data instanceof Function) {
    return data;
  } else if (data instanceof Object) {
    let temp = {};
    Object.keys(data).forEach((key) => {
      temp[key] = _deepClone(data[key]);
    });
    return temp;
  } else {
    return data;
  }
};

export const fetchSectionsForDN = () => {
  return fetch('/section')
    .then((resp) => {
      return resp.json();
    })
    .then((respData) => {
      return respData.data.map((d) => {
        return {
          value: d.value,
          label: d.description,
        };
      });
    })
    .catch((error) => {
      throw error;
    });
};

export const revisedOrOriginal = (quote) => {
  if (quote.revisedPrice) {
    return (
      <React.Fragment>
        <span>{currencyFormatter(quote.revisedPrice)}</span>
        {` `}(<span style={{ textDecoration: 'line-through' }}>{currencyFormatter(quote.price)}</span>)
      </React.Fragment>
    );
  } else {
    return currencyFormatter(quote.price);
  }
};

export function totalKmsSubtract(currentKm, lastServiceKm) {
  return parseInt(currentKm) - parseInt(lastServiceKm) || 0;
}

export const roles = {
  admin: 'Admin', // Web Role
  'super-admin': 'Super Admin', // Web Role
  'store-manager': 'Cash Collector', // Store Manager -> Cash Collector (Mobile Role)
  'store-operator': 'Store Operator', // Web Role
  'fixed-asset-manager': 'Fixed Asset Manager', // Web Role
  'fixed-asset-admin': 'Fixed Asset Admin', //Web Role
  'vehicle-manager': 'Vehicle Manager', // Web Role
  'machine-manager': 'Machine Manager', // Web Role
  'machine-admin': 'Machine Admin', // Web Role
  'coupon-manager': 'Coupon Manager', // Mobile Role
  'coupon-admin': 'Coupon Admin', // Web Role
  'festival-manager': 'Festival Manager', // Web Role
  'festival-admin': 'Festival Admin', // Web Role
  'inventory-admin': 'Inventory Admin', // Web Role
  'inventory-manager': 'Inventory Manager', // Web Role
  'jw-collector': 'JW Collector', // Web Role
  'cake-admin': 'Cake Admin', // Web Role
  'cake-manager': 'Cake Manager', // Web Role
  'agreement-admin': 'Agreement Admin', // Web Role
  'ads-manager': 'Ads Manager', // Web Role
};

export const banks = {
  'hdfc-bank': 'HDFC Bank',
  'icici-bank': 'ICICI Bank',
  'axis-bank': 'AXIS Bank',
};

export const months = {
  1: 'January',
  2: 'February',
  3: 'March',
  4: 'April',
  5: 'May',
  6: 'June',
  7: 'July',
  8: 'August',
  9: 'September',
  10: 'October',
  11: 'November',
  12: 'December',
};

export const fetchBillAmountForReport = (billDetails, year) => {
  const paymentFinancialYear = {};
  [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].forEach((num) => {
    paymentFinancialYear[`${num}-${num > 3 ? year : year + 1}`] = 0;
  });
  billDetails.forEach((bill) => {
    paymentFinancialYear[`${bill.month}-${bill.year}`] = bill.amount;
  });
  return paymentFinancialYear;
};

export const GetFinancialYearsArray = (startYear = 2021) => {
  const today = moment();
  const currentYear = today.month() >= 3 ? today.year() : today.year() - 1;

  const years = Array.from({ length: currentYear - startYear + 1 }, (_, i) => startYear + i);
  return years;
};

export const GenerateYearRange = (startDate, endDate) => {
  // Extract years from the dates
  const startYear = parseInt(startDate.split('-')[0]);
  const endYear = parseInt(endDate.split('-')[0]);

  // Generate an array of years from startYear to endYear inclusive
  const years = [];
  for (let year = startYear; year <= endYear; year++) {
    years.push(year);
  }

  return years;
};

export const QrCodeDownload = (elementId, text1, text2) => {
  const svg = document.getElementById(elementId);
  if (svg) {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const _data = new XMLSerializer().serializeToString(svg);
    const DOMURL = window.URL || window.webkitURL || window;
    const img = new Image();
    const svgBlob = new Blob([_data], { type: 'image/svg+xml;charset=utf-8' });
    const url = DOMURL.createObjectURL(svgBlob);

    img.onload = function () {
      // Create a much larger canvas for high-quality QR code
      const padding = 40;
      const textHeight = 50; // Increased space for text
      const scaleFactor = 3; // Scale up for better quality
      canvas.width = (img.width * scaleFactor) + (padding * 2);
      canvas.height = (img.height * scaleFactor) + (padding * 2) + (textHeight * 2);

      // Fill background with white
      ctx.fillStyle = 'white';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // Enable high-quality image rendering
      ctx.imageSmoothingEnabled = false;

      // Draw the QR code in the middle at larger size
      ctx.drawImage(
        img,
        padding,
        textHeight + padding,
        img.width * scaleFactor,
        img.height * scaleFactor
      );

      // Add the GRN number text at the top with larger font
      ctx.fillStyle = 'black';
      ctx.font = 'bold 24px Arial';
      ctx.textAlign = 'center';
      ctx.fillText(text1, canvas.width / 2, textHeight);

      // Add the supplier name text at the bottom with larger font
      ctx.fillText(text2, canvas.width / 2, (img.height * scaleFactor) + padding + textHeight + (textHeight / 2));

      DOMURL.revokeObjectURL(url);

      // Use higher quality PNG output
      const pngUrl = canvas.toDataURL('image/png', 1.0);
      const link = document.createElement('a');
      link.download = `${text1}-QR.png`;
      link.href = pngUrl;
      link.click();
    };
    img.src = url;
  }
}
